// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
import { LoginResponseFragmentDoc } from './fragments/loginResponse.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const LoginWithAppleDocument = gql`
    mutation loginWithApple($credentials: CustomerRegistrationByAppleInput!, $locale: Locale!, $isConsultant: Boolean!) {
  loginWithApple(credentials: $credentials) {
    ...loginResponse
  }
}
    ${LoginResponseFragmentDoc}`;

export function useLoginWithAppleMutation() {
  return Urql.useMutation<SchemaTypes.LoginWithAppleMutation, SchemaTypes.LoginWithAppleMutationVariables>(LoginWithAppleDocument);
};